import { useCallback } from 'react'

import useQuestionField from '@v4/hooks/questions/useQuestionField'
import QuizQuestionsSelector from '@v4/utils/selectors/QuizQuestionsSelector'
import QuestionsBuilderSelector from '@v4/utils/selectors/QuestionsBuilderSelector'
import QuestionsBuilderModel from '@v4/store/builderStore/models/QuestionsBuilder.model'
import AppStore from '@v4/store/appStore'
import ScorecardSelector from '@v4/utils/selectors/ScorecardSelector'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import PageBuilderModel from '@v4/store/builderStore/models/PageBuilder.model'

export const useQuestionTitle = ({ className, questionId, shadow, align, placeholder }) => {
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const isQuestionBuilderMode = PageBuilderSelector.useIsQuestionsMode()
	const value = useQuestionField(questionId, 'question')
	const { updateQuestion } = QuizQuestionsSelector.useActions()
	const { setQuestionTab } = QuestionsBuilderSelector.useActions()
	const { setSidebarMode } = PageBuilderSelector.useActions()
	const locked = ScorecardSelector.useIsQuestionsLocked()

	const handleChange = useCallback(
		newValue => {
			updateQuestion({
				id: questionId,
				question: newValue,
			})
		},
		[questionId, updateQuestion],
	)

	const handleFocus = useCallback(() => {
		setSidebarMode(PageBuilderModel.SIDEBAR_MODE.QUESTIONS)
		setQuestionTab(QuestionsBuilderModel.QUESTION_TAB.SETTINGS)
	}, [setQuestionTab, setSidebarMode])

	return [
		{
			className,
			shadow,
			value,
			align,
			editable: !locked && isBuilderMode && isQuestionBuilderMode,
			placeholder,
			key: questionId,
		},
		{ handleChange, handleFocus },
	]
}
